import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import Icon from './Icon';
import Picture from './Picture';
import s from './HomeCarousel.style';

class HomeCarousel extends Component {
  constructor(props) {
    super(props);
    this.swiperInstance = null;
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);
  }

  goNext() {
    if (this.swiperInstance) {
      this.swiperInstance.slideNext();
    }
  }

  goPrev() {
    if (this.swiperInstance) {
      this.swiperInstance.slidePrev();
    }
  }

  render() {
    return (
      <div className={css(s.heroWrapper)}>
        <Swiper
          className={css(s.carouselWrapper)}
          modules={[Autoplay]}
          speed={800}
          slidesPerView={1}
          loop
          autoplay={{ delay: 5000, disableOnInteraction: true }}
          onSwiper={swiper => {
            this.swiperInstance = swiper;
          }}
        >
          <SwiperSlide className={css(s.slide)}>
            <div className={css(s.logoWrapper)}>
              <Icon name="logo" className={css(s.logo)} />
            </div>
            <Picture
              alt="The Makeup Lab - professzionális sminkes stúdió Budapest V. kerület"
              className={css(s.slideBg)}
              src={process.env.PUBLIC_URL + '/images/hero-new-1.jpg'}
              width={2048}
              height={1365}
              loading="eager"
              fetchPriority="high"
            />
          </SwiperSlide>
          <SwiperSlide className={css(s.slide)}>
            <Picture
              alt="Smink facechart - The Makeup Lab sminkes munkái"
              className={css(s.slideBg)}
              src={process.env.PUBLIC_URL + '/images/hero-new-3.jpg'}
              width={2048}
              height={1463}
              loading="lazy"
            />
          </SwiperSlide>
          <SwiperSlide className={css(s.slide)}>
            <Picture
              alt="Smink inspiráció - alkalmi és esküvői smink Budapest"
              className={css(s.slideBg, s.slideBgTop)}
              src={process.env.PUBLIC_URL + '/images/hero-new-5.jpg'}
              width={2048}
              height={1463}
              loading="lazy"
            />
          </SwiperSlide>
        </Swiper>
        <button className={css(s.carouselButton, s.carouselButtonLeft)} onClick={this.goPrev}>
          Prev
        </button>
        <button className={css(s.carouselButton, s.carouselButtonRight)} onClick={this.goNext}>
          Next
        </button>
      </div>
    );
  }
}

export default HomeCarousel;
